import React, { Component } from 'react'
import PropTypes from 'prop-types'

import NextButton, { BackButton } from '../../common/NextButton'
import LocationRow from './LocationRow'
import {
  validateEmailMappings,
  mapContactInfo,
} from './contact-info-validations'

class Associations extends Component {
  static propTypes = {
    businesses: PropTypes.arrayOf(PropTypes.object).isRequired,
    doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
    buyPhoneNumbers: PropTypes.func.isRequired,
    customMentionValuesByLocation: PropTypes.object.isRequired,
    extensions: PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    ).isRequired,
    externalOutboundNumbers: PropTypes.arrayOf(PropTypes.object).isRequired,
    hasErrors: PropTypes.bool.isRequired,
    isTopsAdmin: PropTypes.bool.isRequired,
    locations: PropTypes.arrayOf(PropTypes.object).isRequired,
    onBack: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    pms: PropTypes.string.isRequired,
    practiceId: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.string).isRequired,
    refetchLocations: PropTypes.func.isRequired,
    showAdditionalRecipients: PropTypes.bool.isRequired,
    showDoctorSelect: PropTypes.bool.isRequired,
    tier: PropTypes.number.isRequired,
  }

  constructor(props) {
    super(props)
    const {
      customMentionValuesByLocation,
      locations,
      extensions: { location_extensions: selectedExtensions },
    } = props
    const contactInfoMaps = mapContactInfo(locations)
    const cmv = customMentionValuesByLocation || {}
    const cmvKeys = Object.keys(cmv)
    const customMentionValuesByLocationState =
      cmvKeys.length === 0
        ? {}
        : cmvKeys.reduce((acc, locationId) => {
          const values = cmv[locationId]
          acc[locationId] = Array.isArray(values)
            ? values.map(item => ({ ...item }))
            : []
          return acc
        }, {})

    this.state = {
      customMentionValuesByLocationState,
      contactInfoMaps,
      emailsValidation: validateEmailMappings(contactInfoMaps),
      selectedExtensions,
    }

    this.handleFinish = this.handleFinish.bind(this)
  }

  handleFinish = () => {
    const { onFinish, hasErrors, onNext } = this.props
    const { contactInfoMaps, selectedExtensions, customMentionValuesByLocationState } = this.state
    onNext(contactInfoMaps, selectedExtensions, customMentionValuesByLocationState).then(() => {
      if (!hasErrors) onFinish()
    })
  }

  updateExtensions = (locationId, extensionIds) => {
    const { selectedExtensions: oldSelectedExtensions } = this.state
    const updatedExtensions = oldSelectedExtensions
    updatedExtensions[locationId] = extensionIds
    this.setState({
      selectedExtensions: updatedExtensions,
    })
  }

  saveContactInfo = (locationId, contactObj) => {
    const { contactInfoMaps } = this.state
    const curr = contactInfoMaps[locationId] || {}
    const nextContactInfoMaps = {
      ...contactInfoMaps,
      [locationId]: { ...curr, ...contactObj },
    }

    const emailsValidation = validateEmailMappings(
      nextContactInfoMaps,
      locationId,
    )

    this.setState({ contactInfoMaps: nextContactInfoMaps, emailsValidation })
  }

  saveCustomMentionValue = (locationId, { id, newValue }) => {
    const { customMentionValuesByLocationState } = this.state
    const currLocValues = customMentionValuesByLocationState[locationId] || []
    const updatedLocValues = currLocValues.map((item) => {
      if (item.id === id) {
        return { ...item, value: newValue }
      }
      return item
    })
    const nextCustomMentionValuesByLocation = {
      ...customMentionValuesByLocationState,
      [locationId]: updatedLocValues,
    }
    this.setState({
      customMentionValuesByLocationState: nextCustomMentionValuesByLocation,
    })
  }

  saveLocationActive = (locationId, isActive) => {
    const contactInfoMapsNew = this.state.contactInfoMaps
    contactInfoMapsNew[locationId].active = isActive
    this.setState({ contactInfoMaps: contactInfoMapsNew })
  }

  render() {
    const {
      businesses,
      buyPhoneNumbers,
      doctors,
      isTopsAdmin,
      extensions: {
        available_extensions: availableExtensions,
        location_extensions: locationExtensions,
      },
      externalOutboundNumbers,
      locations,
      onBack,
      pms,
      practiceId,
      products,
      refetchLocations,
      showAdditionalRecipients,
      showDoctorSelect,
      tier,
    } = this.props
    const {
      contactInfoMaps,
      emailsValidation,
      customMentionValuesByLocationState,
    } = this.state

    const dso = products && products.indexOf('dso') > -1
    const voip = products && products.indexOf('voip') > -1
    const reminders = products && products.indexOf('reminders') > -1

    return (
      <div>
        <h3>Locations</h3>
        {(reminders || pms !== 'Greyfinch') && (
          <p>
            Note: Whenever you purchase a phone number, please fill in the contact
            info for that location within 5 minutes
          </p>
        )}
        {locations.map(location => (
          <LocationRow
            availableExtensions={availableExtensions || []}
            businesses={businesses}
            buyPhoneNumbers={buyPhoneNumbers}
            contactInfo={contactInfoMaps[location.id]}
            customMentionValues={
              customMentionValuesByLocationState[location.id] || []
            }
            doctors={doctors}
            dso={dso}
            emailsValidation={emailsValidation}
            externalOutboundNumbers={externalOutboundNumbers}
            isTopsAdmin={isTopsAdmin}
            key={location.id}
            location={location}
            locations={locations}
            messageReportEmails={
              contactInfoMaps[location.id].messageReportEmails
            }
            pms={pms}
            practiceId={practiceId}
            purchasedNumbers={
              location.phone_numbers || contactInfoMaps[location.id].numbers
            }
            refetchLocations={refetchLocations}
            reminders={reminders}
            requiresPhoneNumberPurchase={tier !== 4}
            saveContactInfo={this.saveContactInfo}
            saveCustomMentionValue={this.saveCustomMentionValue}
            saveLocationActive={this.saveLocationActive}
            selectedExtensions={
              locationExtensions ? locationExtensions[location.id] : []
            }
            showAdditionalRecipients={showAdditionalRecipients}
            showDoctorSelect={showDoctorSelect}
            smseUsers={location.smse_users}
            updateExtensions={this.updateExtensions}
            voip={voip}
          />
        ))}
        <BackButton handleClick={onBack} />
        <NextButton
          label="finish"
          isSubmit={false}
          handleClick={this.handleFinish}
        />
      </div>
    )
  }
}

export default Associations



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/index.js